module.exports = __webpack_public_path__ + "img/icon-info.32aa8313.svg";